import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription
} from "@/components/ui/card";
import { motion } from "framer-motion";

const CallToActionSection = () => {
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 }
    }
  };

  return (
    <motion.section
      className="py-12 sm:py-16 text-center"
      variants={itemVariants}
    >
      <Card className="max-w-3xl p-8 md:p-12 bg-gradient-to-r from-purple-600 to-primary shadow-xl border-none container mx-auto px-4">
        <CardHeader className="p-0 mb-4">
          <CardTitle className="text-2xl sm:text-3xl font-bold text-primary-foreground">
            Connecting Buyers and Sellers Seamlessly
          </CardTitle>
        </CardHeader>

        <CardContent className="p-0">
          <CardDescription className="text-base sm:text-lg text-primary-foreground/90 leading-relaxed">
            Whether you’re a <strong>buyer</strong> searching for high-quality
            auto parts or a <strong>seller</strong> looking to expand your
            reach, our platform makes it effortless. Discover, list, and connect
            — all in one trusted marketplace built for the automotive community.
          </CardDescription>
        </CardContent>
      </Card>
    </motion.section>
  );
};

export default CallToActionSection;
